module.exports = __webpack_public_path__ + "img/default.1c6857aa.png";